import React from "react";
import { Flex, Modal, Typography } from "antd";
import { CustomTitle } from "../../customTitle";
import styles from "./TermsCondition.module.scss";
import { colors } from "../../../../constants/colors";

const TermsConditionModal = ({ open, onClose, title, data }) => {
  return (
    <>
      <Modal open={open} onCancel={onClose} footer={false}>
        <Flex vertical gap="2rem" align="center" justify="center">
          <CustomTitle
            textDecoration="none"
            justifyContent="center"
            style={{ color: colors.primaryColor }}
          >
            {title}
          </CustomTitle>
          <Flex
            vertical
            gap="0.5rem"
            className={styles.textBoxStyle}
          >
            {data?.map((item, i) => {
              return (
                <React.Fragment key={i}>
                  <Typography.Title level={2}>{item?.message}</Typography.Title>
                  <Typography.Paragraph>
                    {item?.description}
                  </Typography.Paragraph>
                </React.Fragment>
              );
            })}
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};

export default TermsConditionModal;
